<template>

        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>


                    <div class="columns">
                                <div class="column is-3">
                                    <nav class="panel">
                                        <div class="panel-heading"  >
                                            <b-button type="is-success" icon-right="plus" @click="addSpecimenType"/>
<!--                                            {{selectedSpecimensType.name}}-->
                                            &nbsp;
                                            <b-button type="is-success" @click="saveOrderMaster" >Save Order</b-button>
                                        </div>
                                        <div class="panel-block">
                                            <b-table
                                                    :data="isEmpty ? [] : specimenType"
                                                    bordered
                                                    striped
                                                    narrowed
                                                    hoverable
                                                    :loading="isMasterLoading"
                                                    :selected.sync="selectedSpecimensType"
                                                    focusable
                                                    mobile-cards
                                                    draggable
                                                    @dragstart="dragMasterStart"
                                                    @drop="dropMaster"
                                                    @dragover="dragMasterOver"
                                                    @dragleave="dragMasterLeave"
                                                    style="width: 100%">

                                                <b-table-column  label="Edit"  v-slot="props">
                                                    <b-button type="is-warning"
                                                              icon-right="pencil"
                                                              @click="editSpecimenType(props.row.id)"
                                                    />
                                                </b-table-column>
                                                <b-table-column  label="Title"  v-slot="props">
                                                    {{ props.row.name }}
                                                </b-table-column>
                                                <b-table-column  label="Status" v-slot="props"  >
                                                    <b-icon pack="fas" size="is-large"
                                                            :icon="props.row.enable === true ? 'check-circle' : 'times-circle'"
                                                            :style= "props.row.enable === true ? 'color: #42b983' : 'color: firebrick' " >
                                                    </b-icon>
                                                </b-table-column>
                                                <template slot="empty">
                                                    <section class="section">
                                                        <div class="content has-text-grey has-text-centered">
                                                            <p>
                                                                <b-icon
                                                                        icon="emoticon-sad"
                                                                        size="is-large">
                                                                </b-icon>
                                                            </p>
                                                            <p>Nothing here.</p>
                                                        </div>
                                                    </section>
                                                </template>
                                            </b-table>
                                        </div>
                                    </nav>
                                </div>
                                <div class="column is-9">
                                    <nav class="panel">
                                        <div class="panel-heading">
                                            <b-button type="is-success"  icon-right="plus"  @click="addSpecimenDescp"/>
                                            &nbsp;
                                            &nbsp;<b-button type="is-success" @click="saveOrderDetail">Save Order</b-button>
                                            <p class="is-size-4"> {{specimensTypeName}} </p>
                                        </div>
                                        <div class="panel-block">
                                            <b-table
                                                    :data="isEmpty ? [] : specimenDecp"
                                                    bordered
                                                    striped
                                                    narrowed
                                                    hoverable
                                                    :loading="isDetailLoading"
                                                    focusable
                                                    mobile-cards
                                                    draggable
                                                    @dragstart="dragDetailStart"
                                                    @drop="dropDetail"
                                                    @dragover="dragDetailOver"
                                                    @dragleave="dragDetailLeave"
                                                    style="width: 100%">
                                                <b-table-column  label="Edit"  v-slot="props" >
                                                    <b-button type="is-warning" icon-right="pencil" @click="editSpecimenDescp(props.row.id)"></b-button>
                                                </b-table-column>
                                                <b-table-column  label="ID"  v-slot="props">
                                                    {{ props.row.id }}
                                                </b-table-column>
                                                <b-table-column  label="Title"  v-slot="props">
                                                    {{ props.row.name }}
                                                </b-table-column>
                                                <b-table-column  label="Sort"  v-slot="props">
                                                    {{ props.row.sort }}
                                                </b-table-column>
                                                <b-table-column  label="uuid"  v-slot="props">
                                                    {{ props.row.uuid }}
                                                </b-table-column>
                                                <b-table-column  label="Status"  v-slot="props">
                                                    <b-icon pack="fas" size="is-large"
                                                            :icon="props.row.enable === true ? 'check-circle' : 'times-circle'"
                                                            :style= "props.row.enable === true ? 'color: #42b983' : 'color: firebrick' " >
                                                    </b-icon>
                                                </b-table-column>
                                                <b-table-column  label="Delete"   v-slot="props"  >
                                                    <b-button type="is-danger "   icon-right="delete"  @click="deleteSpecimensDescp(props.row.id)"/>
                                                </b-table-column>
                                                <template slot="empty">
                                                    <section class="section">
                                                        <div class="content has-text-grey has-text-centered">
                                                            <p>
                                                                <b-icon
                                                                        icon="emoticon-sad"
                                                                        size="is-large">
                                                                </b-icon>
                                                            </p>
                                                            <p>Nothing here.</p>
                                                        </div>
                                                    </section>
                                                </template>
                                            </b-table>
                                        </div>
                                    </nav>
                                </div>
                            </div>





                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="closeModal">
                        Close
                    </b-button>
                </footer>
            </div>


         <AddEditSpecimensType v-if="isActiveComponentAddEditSpecimensType"
                               :datToChild=datToChildSpecimensType
                               @closeWithNothing="closeWithNothing"
                               @closeWithAddNew="closeWithAddNew"
                               @closeWithEdit="closeWithEdit"/>
          <AddEditSpecimensDesc   v-if="isActiveComponentAddEditSpecimensDesc"
                                  :datToChild=datToChildSpecimensDescp
                                  @closeWithEdit="closeWithEditDescp"
                                  @closeWithAddNew="closeWithAddNewDescp"
                                  @closeWithNothing="closeWithNothingSpecimensDescp"/>
        </b-modal>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getConfigAxios , getBaseURLforBackEnd, genUUID}  from '@/utils.js'
    import AddEditSpecimensType from "./AddEditSpecimensType";
    import AddEditSpecimensDesc from "./AddEditSpecimensDesc";
    import axios from "axios";
    // import axios from "axios";


    export default {
        name: "SpecimensManagement",
        components:{
            AddEditSpecimensType,
            AddEditSpecimensDesc
        },
        computed:{
            ...mapState({
                specimenType : state => state.specimens.specimenType,
                specimenDecp : state => state.specimens.specimenDecp,
                access_token: state => state.master_data.access_token,
            })
        },
        data(){
            return{
                isFullScreenLoading : false,
                isComponentModalActive : false,
                isEmpty : false,
                isMasterLoading: false,
                isDetailLoading: false,
                selectedSpecimensType : null, // {id : ... , name : ... }
                specimensTypeName : '',
                isActiveComponentAddEditSpecimensType: false,
                isActiveComponentAddEditSpecimensDesc: false,
                //
                datToChildSpecimensType : {"mode" : "" , "id": null,"name": "" ,"enable" : false},
                datToChildSpecimensDescp:  {"mode" : "Add" , "idspecimen_type": null ,"idspecimen_name": null, "id": null,"name": "" ,"enable" : null}
                    //{"mode" : "" , "idspecimen_type":  null,"idspecimen_name": "", "id": null,"name": "" ,"enable" : false}
            }
        },
        methods:{
            ...mapActions({
                fetchSpecimenType : 'specimens/fetchSpecimenType',
                fetchSpecimenDescp: 'specimens/fetchSpecimenDescp',
            }),
            doFetchSpecimenType(){
                // console.log('do doFetchSpecimenType')
                const  vm = this
                this.fetchSpecimenType()
                    .then((res)=>{
                        if(res.length>0){
                            vm.selectedSpecimensType = vm.specimenType[0]
                        }
                    })
            },
            deleteSpecimensDescp(_id){


                this.$buefy.dialog.confirm({
                    title: 'Confirm ?',
                    message: `Confirm to delete ?`,
                    cancelText: 'Disagree',
                    confirmText: 'Agree',
                    type: 'is-success',
                    onConfirm: () => {
                                            const datTo = {
                                                "id": _id
                                            }
                                            

                                            const vm = this
                                            this.isFullScreenLoading = true
                                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                                            axios.post(`${getBaseURLforBackEnd()}/api/deletespecimensdescp`,datTo,getConfigAxios())
                                                .then((res)=>{
                                                    if(res.status === 200){
                                                        vm.$buefy.toast.open({
                                                            message: `Success to delete `,
                                                            type: 'is-danger'
                                                        })
                                                        vm.isFullScreenLoading = false
                                                        vm.closeWithEditDescp()
                                                    }
                                                })
                                                .catch((err)=>{
                                                    vm.isFullScreenLoading = false
                                                    console.log(err)
                                                    this.$buefy.dialog.alert({
                                                        title: 'Error',
                                                        message: `${err}   ${err.response.data.msg}`,
                                                        type: 'is-danger',
                                                        hasIcon: true,
                                                        icon: 'times-circle',
                                                        iconPack: 'fa',
                                                        ariaRole: 'alertdialog',
                                                        ariaModal: true
                                                    })
                                                })
                    }
                })





            },
            editSpecimenType(id){
                // console.log(id)
                const dat = this.specimenType.find(dat=>{
                    return dat.id === id
                })
                this.datToChildSpecimensType= {"mode" : "Edit" , "id": id,"name": dat.name,"enable" : dat.enable}
                this.isActiveComponentAddEditSpecimensType = true
            },
            closeWithAddNew(){
                this.isActiveComponentAddEditSpecimensType = false
                this.fetchSpecimenType()
            },
            closeWithEdit(){
                this.isActiveComponentAddEditSpecimensType = false
                this.fetchSpecimenType()
            },
            closeWithNothing(){
                this.isActiveComponentAddEditSpecimensType = false
            },
            addSpecimenType(){
                this.datToChildSpecimensType= {"mode" : "Add" , "id": null,"name": "","enable" : false}
                this.isActiveComponentAddEditSpecimensType = true
                // console.log(this.selectedSpecimensType)
            },

            closeWithEditDescp(){
                this.isActiveComponentAddEditSpecimensDesc = false
                if(this.selectedSpecimensType !== null) {
                    this.fetchSpecimenDescp(this.selectedSpecimensType.id)
                }
            },
            closeWithAddNewDescp(){
                this.isActiveComponentAddEditSpecimensDesc = false
                if(this.selectedSpecimensType !== null) {
                    this.fetchSpecimenDescp(this.selectedSpecimensType.id)
                }
            },
            closeWithNothingSpecimensDescp(){
                this.isActiveComponentAddEditSpecimensDesc = false
            },
            addSpecimenDescp(){
                this.datToChildSpecimensDescp =   {"mode" : "Add" , "idspecimen_type": this.selectedSpecimensType.id ,"idspecimen_name": this.selectedSpecimensType.name, "id": null,"name": "" ,"enable" : null}
                this.isActiveComponentAddEditSpecimensDesc = true
            },
            editSpecimenDescp(id){
                // console.log(JSON.stringify(this.specimensTypeName))
                const dat = this.specimenDecp.find(dat=>{
                    return dat.id === id
                })
                this.datToChildSpecimensDescp = {"mode" : "Edit" , "idspecimen_type": this.selectedSpecimensType.id ,"idspecimen_name": this.selectedSpecimensType.name, "id": id,"name": dat.name ,"enable" : dat.enable}
                this.isActiveComponentAddEditSpecimensDesc = true
            },



            dragDetailStart(payload){
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragDetailOver(payload){
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragDetailLeave(payload){
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropDetail(payload){
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElements(this.specimenDecp , this.draggingRowIndex ,droppedOnRowIndex )
                this.specimenDecp[droppedOnRowIndex]['uuid'] = genUUID(6)
                this.specimenDecp[this.draggingRowIndex]['uuid'] = genUUID(6)
            },


            dragMasterStart(payload){
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragMasterOver(payload){
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragMasterLeave(payload){
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropMaster(payload){
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElements(this.specimenType , this.draggingRowIndex ,droppedOnRowIndex )
                this.specimenType[droppedOnRowIndex]['uuid'] = genUUID(6)
                this.specimenType[this.draggingRowIndex]['uuid'] = genUUID(6)
            },


            swapArrayElements (arr, indexA, indexB) {
                // var temp = arr[indexA];
                // arr[indexA] = arr[indexB];
                // arr[indexB] = temp;
                var temp = arr[indexA];
                arr.splice(indexA,1)
                arr.splice(indexB,0,temp)
                this.reMakeIndexSort(arr)
            },
            reMakeIndexSort(arr) {
                for(var i = 0;i<arr.length;i++){
                    arr[i]['sort'] = i
                }
            },
            closeModal(){
                this.isComponentModalActive = false
            },


            saveOrderMaster(){
                //console.log(this.specimenType)
                const  tmpArr =  this.specimenType.map(dat=>{
                    const tmp = {
                        "id": dat.id,
                        "sort_": dat.sort
                    }
                    return tmp
                })

                const datTo = {
                    "data": tmpArr
                }
                // console.log(JSON.stringify(datTo))

                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatesortorderspecimenstype`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `Success to save order `,
                                type: 'is-success'
                            })
                            vm.isFullScreenLoading = false

                        }
                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })



            } ,

            saveOrderDetail(){
                const  tmpArr =  this.specimenDecp.map(dat=>{
                    const tmp = {
                        "id": dat.id,
                        "sort_": dat.sort
                    }
                    return tmp
                })

                const datTo = {
                    "data": tmpArr
                }
                // console.log(JSON.stringify(datTo))

                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatesortorderspecimensdescp`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `Success to save order `,
                                type: 'is-success'
                            })
                            vm.isFullScreenLoading = false

                        }
                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })


            }


        },
        watch:{
            selectedSpecimensType: function (val) {
                this.isDetailLoading = true
                const vm = this
                this.fetchSpecimenDescp(val.id)
                    .then(()=>{
                        setTimeout(()=>{vm.isDetailLoading = false},500)
                    })
                this.specimensTypeName = val.name
            }
        },

    }
</script>

<style scoped>

</style>